import React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { EditIcon, CloseIcon } from './../../../themes/icons';
import { Loading } from './../../../components/includes/loading';
import { Section, Content, Main, Buttons, FormActions } from './../../../components/includes/container';
import { ToolbarPrimary } from './../../../components/includes/toolbar';
import { BreadcrumbItem } from './../../../components/includes/breadcrumb';
import { Table, Thead, Tbody, Row, Cell, Tresponsive, Tpagination, Ttolbar } from './../../../components/includes/ui/table';
import { Btn, Label } from './../../../components/includes/ui';
import { FormatDate } from './../../../utilities/date';
import { isUndefined, isSorting, isStatus } from './../../../utilities/utils';
import { UserService } from './../../../services';
import Confirm from './../../shared/confirm';

const rows = [
  { id: 'name', sort: true, numeric: false, disablePadding: false, label: 'Nombre' },
  { id: 'email', sort: true, numeric: false, disablePadding: false, label: 'Email' },
  { id: 'profile', sort: true, numeric: false, disablePadding: false, label: 'Perfil' },
  { id: 'created_at', sort: false, numeric: false, disablePadding: false, label: 'Fecha' },
  { id: 'actions', sort: false, numeric: true, disablePadding: false, label: 'Acciones', width:120, minWidth: 120 }
];

class Users extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      loading: false,
      page: 0,
      order: 'asc',
      orderBy: 'name',
      entities: null,
      formDeleteShow: false,
      formDeleteMessage: null
    };
  }

  componentDidMount(){

    // @Pagination
    let page = this.props.match.params.page;

    if(!isUndefined(page)){

      if(!isNaN(page) && page >= 0){

        this._Find(page);

      }else{

        this.props.history.push('/users');

      }

    }else{

      this._Find(this.state.page);

    }

  }

  componentWillReceiveProps(next_props){
    if(next_props.match.params.page !== this.props.match.params.page){
      this._Find(next_props.match.params.page);
    }
  }

  /*
  ** @Service
  ** @Description: FindAll
  */

  _Find = (page) => {

    UserService.get(page).then((response) => {

      this.setState({ loading: true, page: !isUndefined(page) ? parseInt(page,10) : 0, entities: response });

    }).catch((error) => {

      //this.props.AlertShow({ open: true, variant: 'error', message: Error.internal });

    });

  }

  /*
  ** @Service
  ** @Description: Update
  */

  _Update = (id) => {

    UserService.find(id).then((response) => {

      // @Dispatch user
      this.props.Update(response);

      // @Redirect
      this.props.history.push(`/users/update/${ id }`);

    }).catch((error) => {

      this.props.AlertShow({ open: true, variant: 'error', message: Error.internal });

    });

  }

  /*
  ** @Service
  ** @Description: Delete
  */

  _Delete = (id) => {

    UserService.remove(id).then((response) => {

      // @State
      this.setState({ formDeleteShow: false });

      // @Service find all by page
      this._Find(this.props.match.params.page);

      // @Dispatch alert success
      this.props.AlertShow({ open: true, variant: 'success', message: `Exito, el registro fue eliminado.` });

    }).catch((error) => {

      // @Dispatch alert error
      this.props.AlertShow({ open: true, variant: 'error', message: Error.internal });

    });

  }

  /*
  ** @Click
  ** @Description: Update user
  */

  handleUpdate = (id) => {
    this._Update(id);
  }

  /*
  ** @Event
  ** @Description: Delete user
  */

  handleDelete = (id, name) => {
    this.setState({
      id: id,
      formDeleteShow: true,
      formDeleteMessage: `¿Confirma la eliminación de ${ name }?`
    });
  }

  /*
  ** @Click
  ** @Description: Delete user
  */

  handleConfirmDeleteConfirm = () => {
    this._Delete(this.state.id);
  }

  /*
  ** @Click
  ** @Description: Cancel delete user
  */

  handleConfirmDeleteCancel = () => {
    this.setState({ formDeleteShow: false });
  }

  /*
  ** @Handle
  ** @Description: Change page
  */

  handleChangePage = (event, page) => {
    this.setState({ page });
    this.props.history.push(`/users/page/${ page }`);
  };


  render() {

    const { loading, order, orderBy, entities } = this.state;

    return (
      <Section>

        <ToolbarPrimary title="Usuarios"/>
        <BreadcrumbItem to='/users'>Usuarios</BreadcrumbItem>

        <Content>
          <Main>

            <Confirm
               status={ this.state.formDeleteShow }
               message={ this.state.formDeleteMessage }
               cancel={ () => { this.handleConfirmDeleteCancel() } }
               confirm={ () => { this.handleConfirmDeleteConfirm() } }
            />

            <Ttolbar title="Usuarios">
              <Buttons>
                <Btn color="success" aria-label="add" icon="add" component={ NavLink } to="/users/create">
                  Crear usuario
                </Btn>
              </Buttons>
            </Ttolbar>

            { loading ? (

              <div>

                <Tresponsive enabledActions>
                  <Table>

                    <Thead rows={ rows } order={ order } orderBy={ orderBy } onRequestSort={ this.handleRequestSort }/>

                    <Tbody>

                      { entities.users.length > 0 ? (

                        entities.users.sort(isSorting(order, orderBy)).map(entity => {
                          return (
                            <Row key={ entity._id }>
                              <Cell>{ entity.name } { entity.surname }</Cell>
                              <Cell>{ entity.email }</Cell>
                              <Cell>
                                <Label variant={ entity.status ? "success" : "danger"}>
                                  { isStatus(entity.status) }
                                </Label>
                              </Cell>
                              <Cell>
                                <FormatDate value={ entity.created_at }/>
                              </Cell>
                              <Cell numeric>
                                <Btn color="danger" size="xsmall" onClick={ () => { this.handleDelete(entity._id, `${ entity.name} ${ entity.surname}`) } }>
                                  <CloseIcon fontSize="small"/>
                                </Btn>
                                <Btn color="primary" size="xsmall" onClick={ () => { this.handleUpdate(entity._id) } }>
                                  <EditIcon fontSize="small"/>
                                </Btn>
                              </Cell>
                            </Row>
                          );
                        })

                      ) : (

                        <Row key="1">
                          <Cell colSpan={ rows.length }>No se encontraron resultados.</Cell>
                        </Row>

                      )}

                    </Tbody>
                  </Table>
                </Tresponsive>

                { entities.users.length > 0 && (
                  <FormActions disablePadding>
                    <Tpagination count={ entities.total } page={ this.state.page } onChangePage={ this.handleChangePage } />
                  </FormActions>
                )}

              </div>

            ) : (
              <Loading variant="primary"/>
            ) }

          </Main>
        </Content>
      </Section>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    Alert: state.Alert,
    UserUpdate: state.UserUpdate
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    AlertShow: (data) => {
      dispatch({
        type: 'ALERT_SHOW',
        data: data
      });
    },
    Update: (data) => {
      dispatch({
        type: 'USER_UPDATE',
        data: data
      });
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Users);
